module.exports = __webpack_public_path__ + "static/media/pyv-edit-delete-access-editor.1ce7d9a0.gif";